import React, { useEffect, useMemo, useState } from 'react';
import { DireccionesNegocioAdapter } from '../../../../../infraestructure/persistence/rest/DireccionesNegocioAdapter';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboDireccionesNegocio from './combo';
import { useNotifications } from '../../../../../shared/hooks/Notifications';

export const ComboDireccionesNegocioContainer = (props: any) => {
  
  const api = new DireccionesNegocioAdapter();
  const { exceptionError, resultError } = useNotifications();
  let [dns, setDns] = useState<any>(undefined)
  let result: any;
  
  useEffect(()=>{
    getDireccionesNegocio();
  },[])

	const getDireccionesNegocio = async() =>{
    try {
      result = await api.ListarDN();
      if(result.data && result.data!=="")
			{
        const dnsUserFilter = props.dnFilters && result.data.filter((f:any)=> props.dnFilters.includes(f.idDN)) || [];
        const resultDN = (props.dnFilters && dnsUserFilter.length>0) ? dnsUserFilter : result.data;
        setDns([...resultDN]);
      }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }

  //const IsDisabled = useMemo(()=> (props.isDisabled && props.) ? {...{isDisabled:true}} : {...{isDisabled:false}},[props,dns])

  // return <ComboDireccionesNegocio {...{...props,...IsDisabled}} options={dns}/>

  return <ComboDireccionesNegocio {...props} options={dns}/>
};

export default ComboDireccionesNegocioContainer;